/**
 * @summary - Component that Provides PPM Planner Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { BemsGraph, FemsGraph,MasterGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import  ReArrangeLabel  from "../../components/commoncomponents/ReArrangeLabel";
import { getAuthToken } from "../../utility/tokenUtility";


async function getAssetNoDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleDetailsAssetNoFetch/${facilityId},${workGroupId}?size=10000`);
     if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"assetno","label"); 
  return reArrangedData;
  }
  return response;
}
async function getAssetNoDetailsForEdit(facilityId,workGroupId) {
  const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetAssetandWorkGroupFetchList/${facilityId},${workGroupId}?PageSize=3000`);
 if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"assetno","label"); 
  return reArrangedData;
  }
  return response;
}
async function getBemsAssetNoDetailsForEdit(facilityId,workGroupId) {
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetAssetandWorkGroupFetchList/${facilityId},${workGroupId}?PageSize=3000`);
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"assetno","label"); 
  return reArrangedData;
  }
  return response;
}
async function getBemsAssetNoDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleDetailsAssetNoFetch/${facilityId},${workGroupId}?size=10000`);
     if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"assetno","label"); 
  return reArrangedData;
  }
  return response;
}
async function getTaskCodeDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleDetailsTaskCodeFetch/${facilityId},${workGroupId}?size=10000`); 
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"taskdesc","label"); 
  return reArrangedData;
  }
  return response;
}
async function getBemsTaskCodeDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleDetailsTaskCodeFetch/${facilityId},${workGroupId}?size=10000`); 
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"taskdesc","label"); 
  return reArrangedData;
  }
  return response;
}
async function getPpmDetails(facilityId, workGroupId, yearId) {
  const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
  const response = await Axios.get(`${FemsGraph}/api/PPMScheduleReport/GetFemPPMScheduleDetailsGet/${facilityId},${workGroupId},${yearId},${token}?size=10000`);
 
   return response;
 }
 
 async function getBemsPpmDetails(facilityId, workGroupId, yearId) {
  const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
  const response = await Axios.get(`${BemsGraph}/api/PPMScheduleReport/GetBemPPMScheduleDetailsGet/${facilityId},${workGroupId},${yearId},${token}?size=10000`);
 
    return response;
  }

// async function getPpmDetails(facilityId, workGroupId, yearId) {
//   const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleDetailsGet/${facilityId},${workGroupId},${yearId}?size=10000`);
 
//    return response;
//  }
 
//  async function getBemsPpmDetails(facilityId, workGroupId, yearId) {
//    const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleDetailsGet/${facilityId},${workGroupId},${yearId}?size=10000`);
 
//     return response;
//   }

async function getPpmShowSchedule(facilityId,workgroupId,yearId) { 
const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleTrackGet/${facilityId},${workgroupId},${yearId}?size=10000`); 

  return response;
}
async function getBemsPpmShowSchedule(facilityId,workgroupId,yearId) {
 
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleTrackGet/${facilityId},${workgroupId},${yearId}?size=10000`); 

    return response;
  }
  async function getPpmGenerationShowSchedule(facilityId,workgroupId,year,month) { 
    const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMGenerationScheduleTrackGet/${facilityId},${workgroupId},${year},${month}?size=10000`); 
    
      return response;
    }
    async function getBemsPpmGenerationShowSchedule(facilityId,workgroupId,year,month) {
     
      const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMGenerationScheduleTrackGet/${facilityId},${workgroupId},${year},${month}?size=10000`); 
    
        return response;
      }
async function addPpmscheduleTracks(values) { 
 const response = await Axios.post(`${FemsGraph}/api/femppmscheduletracks`,values); 

  return response;
}
async function addBemsPpmscheduleTracks(values) { 
  const response = await Axios.post(`${BemsGraph}/api/bemppmscheduletracks`,values); 
   if(response?.status !== 'error'){
 
   }
   return response;
 }
async function ppmscheduleDropDownList(facilityId,companyId) { 
  const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleDetailsDropdownList/${companyId}/${facilityId}?size=10000`); 
   return response;
 }
 async function ppmBemsScheduleDropDownList(facilityId,companyId) { 
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleDetailsDropdownList/${companyId}/${facilityId}?size=10000`); 
   return response;
 }
 async function getVendorList(companyId) { 
  const response = await Axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?size=10000`); 

   if(response?.status !== 'error'){
    const reArrangedData=ReArrangeLabel(response?.data,"vendorname","label"); 
    return reArrangedData;
   }
   return response;
 }
 async function updateAllApprovedBy(id,values) { 
  const response = await Axios.update(`${FemsGraph}/api/Graphppmscheduledetails/${id}`,values); 

   return response;
 }
 
 async function updateAllBemsApprovedBy(id,values) { 
  const response = await Axios.update(`${BemsGraph}/api/Graphppmscheduledetails/${id}`,values); 

   return response;
 }
 async function removePpmSchedule(id) { 
  const response = await Axios.remove(`${FemsGraph}/api/femppmscheduledetails/${id}`); 

   return response;
 }
 async function removeBemsPpmSchedule(id) { 
  const response = await Axios.remove(`${BemsGraph}/api/bemppmscheduledetails/${id}`); 
 
   return response;
 }
 async function addPpmscheduleTracksDelete(id) { 
  const response = await Axios.remove(`${FemsGraph}/api/femppmscheduletracks/GetFemppmscheduletrack/${id}`); 
  // const response = await Axios.remove(`${FemsGraph}/api/femppmscheduletracks/${id}`); 
 
   return response;
 }
 async function addBemsPpmscheduleTracksDelete(id) { 
  const response = await Axios.remove(`${BemsGraph}/api/bemppmscheduletracks/GetBemppmscheduletrack/${id}`); 

   return response;
 }


 async function getBemsWOScheduledList(assetId) { 
  //const response = await Axios.get(`${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemSchedule/${facilityId}?PageNumber=1&PageSize=100000`); 
 const response = await Axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetscheduledwoListbyAssetId/${assetId},1,100`)
 return response;
 }


 async function getWOScheduledList(assetId) { 
  //const response = await Axios.get(`${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemSchedule/${facilityId}?PageNumber=1&PageSize=100000`); 
  //const response = await Axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetscheduledwoListbyAssetId/DB569C78-74A1-4C9D-99EC-3C94D408D713,1,100`); 
 const response = await Axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetscheduledwoListbyAssetId/${assetId},1,100`)
 return response;
 }

 async function cancelWorkOrders(workOrderId,values) { 
  const response = await Axios.update(`${FemsGraph}/api/femscheduledworkorderheaders/${workOrderId}`,values); 
  return response;
 }
 async function cancelBemsWorkOrders(workOrderId,values) { 
  const response = await Axios.update(`${BemsGraph}/api/bemscheduledworkorderheaders/${workOrderId}`,values); 
  return response;
 }

 async function updatePPMplannerAssigneorTaskCode(plannerId,staffid,vendorid,taskcodeid,service) { 
  const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
  const checkFemorBem = service === "FEMS" ? "femppmscheduletracks" : "bemppmscheduletracks"
  const response = await Axios.update(`${checkGraph}/api/${checkFemorBem}/UpdateTracktable/${plannerId}/${staffid}/${vendorid}/${taskcodeid}`); 
  return response;
 }

const PpmPlannerRepository = {
  getPpmGenerationShowSchedule,
  getBemsPpmGenerationShowSchedule,
  getAssetNoDetails,
  getTaskCodeDetails,
  getPpmDetails,
  addPpmscheduleTracks,
  ppmscheduleDropDownList,
  getPpmShowSchedule,
  getBemsPpmShowSchedule,
  updateAllApprovedBy,
  updateAllBemsApprovedBy,
  removePpmSchedule,
  getVendorList,
  addPpmscheduleTracksDelete,
  getBemsPpmDetails,
  getBemsAssetNoDetails,
  getBemsTaskCodeDetails,
  ppmBemsScheduleDropDownList,
  addBemsPpmscheduleTracks,
  addBemsPpmscheduleTracksDelete,
  removeBemsPpmSchedule,
  getAssetNoDetailsForEdit,
  getBemsAssetNoDetailsForEdit,
  getBemsWOScheduledList,
  getWOScheduledList,
  updatePPMplannerAssigneorTaskCode,
  cancelWorkOrders,
  cancelBemsWorkOrders
  };    
    
export default PpmPlannerRepository;
    